export default "__VITE_ASSET__Bm8Vp2GI__"